import moment from 'moment-timezone'
import { SharedSettings } from 'settings/SharedSettings'

export const getMomentDateMin = (timezone: string) => {
  return moment.tz(SharedSettings.FIRST_DAY_OF_DATA_FOR_MANY_THINGS, timezone)
}
